/* Coverly collection filters — size chip with a popover, live card pricing.

   The maths is NOT done here. The bar collects the product handles on the page
   and asks the CRM to price them all at one size, so a collection card and the
   configurator behind it are answered by the same calculator. Before a size is
   applied every card keeps Shopify's own "From $x", and anything the CRM cannot
   price falls straight back to it. */
(function () {
  var MM_PER_INCH = 25.4;

  // Same fraction ladders the calculator offers, so a size typed here can be
  // typed identically in the configurator.
  function fractionOptions(mode) {
    if (mode === "decimal") return [{ label: "—", value: 0 }];
    var denom = mode === "sixteenths" ? 16 : 8;
    var out = [{ label: "—", value: 0 }];
    for (var n = 1; n < denom; n++) {
      var g = gcd(n, denom);
      out.push({ label: n / g + "/" + denom / g, value: n / denom });
    }
    return out;
  }
  function gcd(a, b) { return b ? gcd(b, a % b) : a; }

  function money(n) { return "$" + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); }

  function fmtInches(v) {
    var whole = Math.floor(v + 1e-9);
    var frac = v - whole;
    if (frac < 1e-9) return whole + '"';
    var best = null;
    [8, 16].forEach(function (d) {
      var n = Math.round(frac * d);
      if (n > 0 && n < d && Math.abs(n / d - frac) < 1e-6 && !best) {
        var g = gcd(n, d);
        best = n / g + "/" + d / g;
      }
    });
    return best ? whole + " " + best + '"' : v.toFixed(2) + '"';
  }

  // A facet click is a real page navigation, so the chosen size has to travel
  // in the URL or it would be lost every time someone ticks a colour. Stored in
  // inches (cf_w/cf_h) with the unit the shopper is reading in (cf_u).
  function carrySize(url) {
    var here = new URLSearchParams(location.search);
    var w = here.get("cf_w"), h = here.get("cf_h"), u = here.get("cf_u");
    if (!w || !h) return url;
    var next = new URL(url, location.origin);
    next.searchParams.set("cf_w", w);
    next.searchParams.set("cf_h", h);
    if (u) next.searchParams.set("cf_u", u);
    return next.pathname + next.search;
  }

  // carrySize only reaches links this section renders. Someone leaving through
  // the main nav or the category tiles is following a link written elsewhere,
  // so the size is also parked per tab and picked up again on the next
  // collection page. Session rather than local on purpose: a size is the window
  // being measured today, and silently re-pricing a collection weeks later
  // against a half-remembered measurement is worse than asking for it again.
  var SIZE_KEY = "coverly:cf:size";

  function remember(w, h, u) {
    try { sessionStorage.setItem(SIZE_KEY, JSON.stringify({ w: w, h: h, u: u })); } catch (e) { /* private mode */ }
  }
  function forget() {
    try { sessionStorage.removeItem(SIZE_KEY); } catch (e) { /* private mode */ }
  }
  function recall() {
    try {
      var v = JSON.parse(sessionStorage.getItem(SIZE_KEY) || "null");
      return v && v.w > 0 && v.h > 0 ? v : null;
    } catch (e) { return null; }
  }

  // One controller for the whole row: opening a chip closes its neighbours,
  // and a click anywhere else closes the lot.
  function wirePopovers(root) {
    if (root.dataset.cfPops === "true") return null;
    root.dataset.cfPops = "true";

    var filters = [].slice.call(root.querySelectorAll("[data-cf-filter]"));

    function closeAll(except) {
      filters.forEach(function (f) {
        if (f === except) return;
        var p = f.querySelector("[data-cf-pop]");
        var t = f.querySelector("[data-cf-toggle]");
        if (p) p.hidden = true;
        if (t) t.setAttribute("aria-expanded", "false");
      });
    }

    filters.forEach(function (f) {
      var t = f.querySelector("[data-cf-toggle]");
      var p = f.querySelector("[data-cf-pop]");
      if (!t || !p) return;
      t.addEventListener("click", function () {
        var on = p.hidden;
        closeAll(f);
        p.hidden = !on;
        t.setAttribute("aria-expanded", String(on));
        if (on) {
          var first = p.querySelector("input, a");
          if (first) first.focus();
        }
      });
    });

    document.addEventListener("click", function (e) {
      var inside = filters.some(function (f) { return f.contains(e.target); });
      if (!inside) closeAll(null);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var openOne = filters.filter(function (f) {
        var p = f.querySelector("[data-cf-pop]");
        return p && !p.hidden;
      })[0];
      if (!openOne) return;
      closeAll(null);
      var t = openOne.querySelector("[data-cf-toggle]");
      if (t) t.focus();
    });

    // Sort is a plain navigation, same as a facet — it keeps the active
    // filters, drops back to page 1, and carries the size along.
    var sort = root.querySelector("[data-cf-sort]");
    if (sort) {
      sort.addEventListener("change", function () {
        var q = new URLSearchParams(location.search);
        q.set("sort_by", sort.value);
        q.delete("page");
        location.href = carrySize(location.pathname + "?" + q.toString());
      });
    }

    // Shopify builds url_to_add from the filter params it knows about, so the
    // size has to be re-attached on the way out.
    root.querySelectorAll("[data-cf-facet]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        var href = a.getAttribute("href");
        if (!href) return;
        var withSize = carrySize(href);
        if (withSize === href) return;
        e.preventDefault();
        location.href = withSize;
      });
    });

    // Narrow screens fold the facets behind one button. Collapsing also shuts
    // any popover left open inside, which would otherwise be hidden but still
    // flagged as expanded to a screen reader.
    var more = root.querySelector("[data-cf-more]");
    var facets = root.querySelector("[data-cf-facets]");
    if (more && facets) {
      more.addEventListener("click", function () {
        var on = facets.classList.toggle("is-open");
        more.setAttribute("aria-expanded", String(on));
        if (!on) closeAll();
      });
    }

    return { closeAll: closeAll };
  }

  function init(root) {
    if (root.dataset.cfInit === "true") return;
    root.dataset.cfInit = "true";

    var base = (root.dataset.base || "").replace(/\/+$/, "");
    var mode = root.dataset.fractions || "eighths";

    var filter = root.querySelector("[data-cf-size]");
    if (!filter) return;
    var toggle = filter.querySelector("[data-cf-toggle]");
    var pop = filter.querySelector("[data-cf-pop]");
    var chipLabel = root.querySelector("[data-cf-chip-label]");
    var baseLabel = chipLabel ? chipLabel.textContent : "Size";
    var wEl = root.querySelector("[data-cf-width]");
    var hEl = root.querySelector("[data-cf-height]");
    var wFrac = root.querySelector("[data-cf-width-frac]");
    var hFrac = root.querySelector("[data-cf-height-frac]");
    var noteEl = root.querySelector("[data-cf-note]");
    var unit = "in";

    fractionOptions(mode).forEach(function (o) {
      [wFrac, hFrac].forEach(function (sel) {
        if (!sel) return;
        var op = document.createElement("option");
        op.value = String(o.value);
        op.textContent = o.label;
        sel.appendChild(op);
      });
    });

    // Fractions are an imperial idea; in mm the whole number carries it.
    function syncUnit() {
      root.querySelectorAll("[data-cf-unit]").forEach(function (b) {
        b.classList.toggle("is-on", b.dataset.cfUnit === unit);
      });
      var showFrac = unit === "in" && mode !== "decimal";
      [wFrac, hFrac].forEach(function (s) { if (s) s.hidden = !showFrac; });
      if (wEl) wEl.step = unit === "mm" ? "1" : "1";
      if (wEl) wEl.placeholder = unit === "mm" ? "610" : "24";
      if (hEl) hEl.placeholder = unit === "mm" ? "914" : "36";
    }

    // Everything downstream works in inches; mm is converted at the edge.
    function dims() {
      var w = parseFloat(wEl && wEl.value) || 0;
      var h = parseFloat(hEl && hEl.value) || 0;
      if (unit === "in") {
        w += parseFloat(wFrac && wFrac.value) || 0;
        h += parseFloat(hFrac && hFrac.value) || 0;
      } else {
        w = w / MM_PER_INCH;
        h = h / MM_PER_INCH;
      }
      return { w: w, h: h };
    }

    function cards() {
      var out = [];
      document.querySelectorAll(".grid__item").forEach(function (item) {
        var link = item.querySelector('a[href*="/products/"]');
        // The Coverly card names its own price element; .price is Dawn's, kept
        // for grids still using the stock card. Without the first of these the
        // whole size feature was inert wherever the Coverly card was in use,
        // which is every collection — cards() found nothing and run() returned
        // before it ever called the CRM.
        var price = item.querySelector(".ccard__price, .price");
        if (!link || !price) return;
        var m = link.getAttribute("href").match(/\/products\/([^/?#]+)/);
        if (!m) return;
        // Stash the original markup once so "From $x" is always restorable.
        if (price.dataset.cfOriginal == null) price.dataset.cfOriginal = price.innerHTML;
        out.push({ handle: decodeURIComponent(m[1]).toLowerCase(), price: price });
      });
      return out;
    }

    /* Two different facts, kept apart on purpose.

       The size someone typed is true the moment they type it. Whether the grid
       could be priced at that size depends on a call to the CRM. Bundling them
       meant a failed lookup reset the chip to "Size", so an entered size looked
       like no size at all — and the one control that could correct it gave no
       sign of holding anything. */
    function sizeLabel(d) {
      return unit === "in"
        ? fmtInches(d.w) + " × " + fmtInches(d.h)
        : Math.round(d.w * MM_PER_INCH) + " × " + Math.round(d.h * MM_PER_INCH) + "mm";
    }

    function markSized(d) {
      if (chipLabel) chipLabel.textContent = sizeLabel(d);
      if (toggle) toggle.classList.add("is-set");
      root.classList.add("cf--active");
    }

    function clearSized() {
      if (chipLabel) chipLabel.textContent = baseLabel;
      if (toggle) toggle.classList.remove("is-set");
      root.classList.remove("cf--active");
    }

    /** Prices only — the chip keeps whatever size it was given. */
    function restore() {
      cards().forEach(function (c) {
        if (c.price.dataset.cfOriginal != null) c.price.innerHTML = c.price.dataset.cfOriginal;
        c.price.classList.remove("cf-priced");
      });
      if (noteEl) noteEl.hidden = true;
    }

    function apply(prices, d) {
      var list = cards(), priced = 0;
      list.forEach(function (c) {
        var p = prices[c.handle];
        if (typeof p !== "number") {
          // Not linked to a calculator: leave Shopify's own price rather than
          // blanking it or showing a guess.
          if (c.price.dataset.cfOriginal != null) c.price.innerHTML = c.price.dataset.cfOriginal;
          c.price.classList.remove("cf-priced");
          return;
        }
        priced++;
        c.price.classList.add("cf-priced");
        c.price.innerHTML = '<span class="price-item price-item--regular cf-amount">' + money(p) + "</span>";
      });

      var label = sizeLabel(d);
      if (noteEl) {
        noteEl.hidden = false;
        noteEl.textContent = priced
          ? "Showing your price for " + label + (priced === list.length ? "" : " where available")
          : "No products here price at that size yet.";
      }
    }

    // Written on apply, read back on load, so a facet navigation — or a shared
    // link — lands with the same size still priced in.
    function writeSize(d) {
      var q = new URLSearchParams(location.search);
      q.set("cf_w", d.w.toFixed(4));
      q.set("cf_h", d.h.toFixed(4));
      q.set("cf_u", unit);
      history.replaceState(null, "", location.pathname + "?" + q.toString());
      remember(d.w, d.h, unit);
    }

    function clearSize() {
      var q = new URLSearchParams(location.search);
      ["cf_w", "cf_h", "cf_u"].forEach(function (k) { q.delete(k); });
      forget();
      var qs = q.toString();
      history.replaceState(null, "", location.pathname + (qs ? "?" + qs : ""));
    }

    // Inches are canonical; the inputs are filled in whatever unit was in use.
    function fillInputs(wIn, hIn) {
      if (unit === "mm") {
        if (wEl) wEl.value = String(Math.round(wIn * MM_PER_INCH));
        if (hEl) hEl.value = String(Math.round(hIn * MM_PER_INCH));
        return;
      }
      [[wEl, wFrac, wIn], [hEl, hFrac, hIn]].forEach(function (pair) {
        var el = pair[0], sel = pair[1], v = pair[2];
        var whole = Math.floor(v + 1e-9);
        var frac = v - whole;
        if (el) el.value = String(whole);
        if (!sel) return;
        var denom = mode === "sixteenths" ? 16 : 8;
        var n = Math.round(frac * denom);
        // A fraction that is not on the ladder rounds up into the whole number.
        if (n >= denom) { n = 0; if (el) el.value = String(whole + 1); }
        sel.value = String(n / denom);
        if (sel.selectedIndex < 0) sel.value = "0";
      });
    }

    function readSize() {
      var q = new URLSearchParams(location.search);
      var w = parseFloat(q.get("cf_w")), h = parseFloat(q.get("cf_h"));
      var u = q.get("cf_u");
      if (!(w > 0 && h > 0)) {
        // Nothing in the URL: this may be a category reached by a link that
        // knows nothing about sizes. run() writes it back into the URL, so the
        // page ends up in the same state either way.
        var kept = recall();
        if (!kept) return false;
        w = kept.w; h = kept.h; u = kept.u;
      }
      if (u === "mm" || u === "in") unit = u;
      syncUnit();
      fillInputs(w, h);
      return true;
    }

    var seq = 0;
    function run() {
      var d = dims();
      if (!(d.w > 0 && d.h > 0)) { clearSized(); return restore(); }
      markSized(d);   // straight away; pricing catches up, or does not
      writeSize(d);
      var list = cards();
      if (!list.length) return;
      var mine = ++seq;
      var handles = list.map(function (c) { return c.handle; });

      fetch(base + "/api/calculator/public/prices?w=" + encodeURIComponent(d.w.toFixed(4)) +
            "&h=" + encodeURIComponent(d.h.toFixed(4)) +
            "&handles=" + encodeURIComponent(handles.join(",")),
            { headers: { Accept: "application/json" } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          if (mine !== seq) return;   // a slower earlier reply must not win
          apply(data.prices || {}, d);
        })
        .catch(function () { if (mine === seq) restore(); });
    }

    // Opening and closing is the row's job (wirePopovers) so that only one
    // chip can be open at a time; the size chip just asks it to shut.
    function open(on) {
      if (!pop || !toggle) return;
      pop.hidden = !on;
      toggle.setAttribute("aria-expanded", String(on));
      if (on && wEl) wEl.focus();
    }
    root.querySelectorAll("[data-cf-unit]").forEach(function (b) {
      b.addEventListener("click", function () { unit = b.dataset.cfUnit; syncUnit(); });
    });
    root.querySelector("[data-cf-apply]").addEventListener("click", function () { run(); open(false); });
    root.querySelector("[data-cf-clear]").addEventListener("click", function () {
      if (wEl) wEl.value = ""; if (hEl) hEl.value = "";
      if (wFrac) wFrac.value = "0"; if (hFrac) hFrac.value = "0";
      clearSize(); clearSized(); restore(); open(false);
    });
    [wEl, hEl].forEach(function (el) {
      el && el.addEventListener("keydown", function (e) { if (e.key === "Enter") { run(); open(false); } });
    });

    // Dawn re-renders the grid on filter/sort/paginate, replacing the cards.
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest(".pagination__item, .facets__form, facet-filters-form")) {
        setTimeout(function () { if (root.classList.contains("cf--active")) run(); }, 400);
      }
    });

    syncUnit();
    if (readSize()) run();
  }

  function initAll() {
    document.querySelectorAll("[data-cf-root]").forEach(function (root) {
      wirePopovers(root);
      init(root);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
})();
